import { generateConfig } from '@helpers/config';

export const getAppConfig = () => {
    return generateConfig();
};
